/* ======================================================================
   Location-Aware Inventory Gate  +  Bundle Builder  +  Cart Drawer
   ====================================================================== */
(function () {
  /* ---------- CONFIG ------------------------------------------------- */
  const PHP_ENDPOINT      = 'https://shopify.api.nomilk.dev/einrum/locations-data.php';
  const ICELAND_COUNTRY   = 'IS';
  const ICELAND_WAREHOUSE = 'IS';
  const DK_WAREHOUSE      = 'DK';
  const CACHE_TTL         = 30_000;                         // ms
  const ERROR_TXT         = 'Ikke på lager i din region';

  /* ---------- STATE -------------------------------------------------- */
  const stockCache = new Map();                             // variantId → {IS, DK, ts}
  let   visitorCountry = detectCountry();
  console.log('[INFO] visitorCountry =', visitorCountry);

  /* ---------- COUNTRY DETECTION ------------------------------------- */
  function detectCountry () {
    const cookie = document.cookie.split('; ')
      .find(c => c.startsWith('_shopify_country='));
    if (cookie)            return cookie.split('=')[1].toUpperCase();
    if (Shopify?.country)  return Shopify.country;
    if (Shopify?.locale)   return Shopify.locale.split('-').pop().toUpperCase();
    return DK_WAREHOUSE;   // fallback
  }

  /* ---------- STOCK FETCH ------------------------------------------- */
  async function fetchStock (variantIds = []) {
    const idsToFetch = variantIds.filter(id => {
      const rec = stockCache.get(id);
      const stale = !rec || Date.now() - rec.ts > CACHE_TTL;
      console.log(`[INFO] cache ${stale ? 'MISS' : 'HIT'} → ${id}`);
      return stale;
    });
    if (!idsToFetch.length) return;

    console.log('[INFO] fetching', idsToFetch);
    const res  = await fetch(PHP_ENDPOINT, {
      method : 'POST',
      headers: {'Content-Type':'application/json'},
      body   : JSON.stringify({ variantIds: idsToFetch })
    });
    if (!res.ok) { console.warn('[INFO] fetch failed'); return; }
    const data = await res.json();
    Object.entries(data).forEach(([id, payload]) =>
      stockCache.set(+id, {...payload, ts: Date.now()})
    );
    console.log('[INFO] payload', data);
  }

  /* ---------- RULE: MAY BUY? ---------------------------------------- */
  function allowedToBuy (variantId, qtyNeeded = 1) {
    const rec = stockCache.get(variantId);
    if (!rec) return true;                                      // optimistic
    const free = visitorCountry === ICELAND_COUNTRY
      ? rec[ICELAND_WAREHOUSE]
      : rec[DK_WAREHOUSE];
    return free >= qtyNeeded;
  }

  /* ========== VARIANT SWATCH UI ===================================== */
  function updateVariantSwatches () {
    console.log('Update swatch');
    document.querySelectorAll('label.color-swatch[data-variant-id]')
      .forEach(label => {
        console.log('LABEL CHANGE');
        const id   = +label.dataset.variantId;
        if (!id) return;

        console.log('The label');
        console.log(label);
        const ok   = allowedToBuy(id);
        //label.style.pointerEvents = ok ? 'auto' : 'none';
        label.classList.toggle('swatch-sold-out', !ok);
        label.querySelector('.no-stock-badge')?.style.setProperty('display', ok ? 'none' : 'block');
      });
  }

  /* ========== PRODUCT PAGE UI ======================================= */
  function toggleAddToCartUI (variantId) {
    console.log('ID?: ', variantId);
    const btn = document.getElementById('AddToCart');
    if (!btn) return;
    const ok  = allowedToBuy(variantId);
    btn.classList.toggle('inactive', !ok);
    btn.textContent         = ok ? 'Læg i kurv' : 'Ikke på lager';
    btn.style.pointerEvents = ok ? 'auto'       : 'none';
  }

  /* ========== BUNDLE BUILDER UI ===================================== */
  function collectBundleVariantIds () {
    return [...document.querySelectorAll('.slide-in__values-container .yarn-color[data-id]')]
      .map(el => +el.dataset.id)
      .filter(Boolean);
  }
  function updateBundleUI () {
    document.querySelectorAll('.slide-in__values-container .yarn-color[data-id]')
      .forEach(el => {
        const id = +el.dataset.id;
        const ok = allowedToBuy(id);
        el.classList.toggle('yarn-sold-out', !ok);
        el.querySelector('input.yarn-input')?.setAttribute('disabled', !ok);
        el.querySelector('.sold-out-badge')?.style.setProperty('display', ok ? 'none' : 'block');
      });
  }

  /* ========== CART DRAWER LOGIC ===================================== */
  function cartVariantId (cartItemEl) {
    /* Extract ID from variant param in link: “…?variant=12345” */
    const link = cartItemEl.querySelector('a[href*="variant="]')?.href || '';
    const id   = +(new URL(link).searchParams.get('variant'));
    return id || null;
  }

  function collectCartVariantIds () {
    return [...document.querySelectorAll('.drawer__cart-items-wrapper .cart-item')]
      .map(cartVariantId)
      .filter(Boolean);
  }

  function refreshCartControls () {
    document.querySelectorAll('.drawer__cart-items-wrapper .cart-item')
      .forEach(el => {
        const id     = cartVariantId(el);
        const qtyInp = el.querySelector('.quantity__input');
        const plus   = el.querySelector('.quantity__button[name="plus"]');
        const errBox = el.querySelector('.cart-item__error-text');

        if (!id || !qtyInp || !plus) return;

        const desired = Number(qtyInp.value) + 1;
        const ok      = allowedToBuy(id, desired);
        plus.classList.toggle('disabled', !ok);
        
        if (!ok) {
          errBox.textContent = ERROR_TXT;
          el.classList.add('error');
        } else {
          errBox.textContent = '';
          el.classList.remove('error');
        }
      });
  }

  /* ---------- EVENT HANDLERS ---------------------------------------- */
  document.addEventListener('click', async evt => {
    const btn = evt.target.closest('.drawer__cart-items-wrapper .quantity__button');
    if (!btn) return;
    const cartItem = btn.closest('.cart-item');
    const id       = cartVariantId(cartItem);
    if (!id) return;

    /* Ensure freshest stock for this line */
    await fetchStock([id]);

    /* Re-check limits */
    refreshCartControls();

    /* Block “plus” if now illegal */
    if (btn.name === 'plus' && btn.classList.contains('disabled')) {
      evt.preventDefault();
      evt.stopPropagation();
      console.log(`[INFO] plus blocked – variant ${id}`);
    }
  });

  /* ---------- INIT -------------------------------------------------- */
  async function init () {
    /* product page */
    if (meta?.product) {
      const ids = meta.product.variants.map(v => v.id);
      await fetchStock(ids);
      updateVariantSwatches();
      toggleAddToCartUI(meta.product.id);
      document.body.addEventListener('variant:changed', async e => {
        const vId = e.detail.variant.id;
        console.log('Variant changed');
        await fetchStock([vId]);
        updateVariantSwatches();
        toggleAddToCartUI(vId);
        updateBundleUI();
      });
    }

    /* bundle builder */
    const bundleIds = collectBundleVariantIds();
    if (bundleIds.length) {
      await fetchStock(bundleIds);
      updateBundleUI();
    }

    /* cart drawer */
    const cartIds = collectCartVariantIds();
    if (cartIds.length) {
      await fetchStock(cartIds);
      refreshCartControls();
    }

    /* refresh on drawer open (Ajax) */
    document.addEventListener('cart:drawerOpened', async () => {
      const ids = collectCartVariantIds();
      if (ids.length) {
        await fetchStock(ids);
        refreshCartControls();
      }
    });
  }

  /* ---------- KICK-OFF ---------------------------------------------- */
  if (document.readyState === 'complete') {
    init();                        // already finished loading
  } else {
    window.addEventListener('load', init);           // after all assets
    document.addEventListener('DOMContentLoaded', init); // fallback
  }

  /* optional watcher for country change */
  setInterval(() => {
    const cur = detectCountry();
    if (cur !== visitorCountry) {
      visitorCountry = cur;
      updateBundleUI();
      refreshCartControls();
    }
  }, 10_000);
})();
